// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"bf54a971","308":"850cbb5b","374":"5ca0191d","859":"3d988de3"}[chunkId] + ".chunk.js";
};